import {labelsummary} from '@/services/forward/out/labelTpick'
import {query} from '@/services/forward/out/SowingPickUp';

export default {
    namespace: 'labelTpick',
    state: {
        data: {
          list: [],
          pagination: {},
        },
        entity: {},
        printList: [],
        electronicList: [],
        showPage: 'query'
      },
      effects: {
        *labelsummary({payload,callback},{call,put}){
           const response= yield call(labelsummary,payload);
          // yield put({
          //   type:'save',
          //   payload:response.data
          // })
          if(callback) callback(response);
        },
        *queryPrintRecords({payload,callback},{call,put}){
          const response = yield call(query, payload);
          if (callback) callback(response);

          if (response && response.success && response.data) {
           yield put({
               type: 'onPrintList',
               payload: {
                  list: response.data.records ? response.data.records : [],
              },
        });
      }

        }
      },
      reducers: {
        save(state, action) {
            return {
              ...state,
              data: action.payload,
            };
          },
          onView(state, action) {
            return {
              ...state,
              entity: action.entity,
              billNumber: undefined,
              entityUuid: undefined
            }
          },
          onPrintList(state, action) {
            return {
              ...state,
              printList: action.payload.list
            }
          },
          onElectronicList(state, action) {
            return {
              ...state,
              electronicList: action.payload.list
            }
          },
          onShowPage(state, action) {
            return {
              ...state,
              showPage: action.showPage,
              entityUuid: action.entityUuid,
              billNumber: action.billNumber
            }
          },
          savePickUp(state, action) {
            return {
              ...state,
              wavePickUpData: action.payload,
            };
          },
          saveAllocateBins(state, action) {
            return {
              ...state,
              allocateBins: action.payload,
            };
          },
          saveCollectBins(state, action) {
            return {
              ...state,
              collectBins: action.payload,
            };
          },
        }
      
}
